import React from 'react'
import { Typography, Box, Stack } from '@mui/material';
import Loader from './Loader';


const ExerciseVideo = ({ name, exerciseVideos }) => {
  // console.log(exerciseVideos.contents.slice(0,3));
  if(!exerciseVideos.length) return <Loader/>
  return (
    <div>
      <Box sx={{ marginTop: { lg: '203px', xs: '20px' } }} p="20px">
        <Typography sx={{ fontSize: { lg: '44px', xs: '25px' } }} fontWeight={700} color="#000" mb="33px">
          Watch <span style={{ color: '#FF2625', textTransform: 'capitalize' }}>{name}</span> exercise videos
        </Typography>
        <Stack sx={{ flexDirection: "row", justifyContent:'space-between' , xs: '0px',px:"5px"  }} justifyContent="flex-start" flexWrap="wrap" alignItems="center">
          {
            exerciseVideos.contents.slice(0, 3).map((item,index)=>(
              <a href={`https://www.youtube.com/watch?v=${item.video.videoId}`} target="_blank" rel="noreferrer" >
                <img src={item.video?.thumbnails[0].url}  style={{ borderTopLeftRadius: '20px' }}
                  alt={item.video.title} />
                <Box>
                  <Typography sx={{ fontSize: { lg: '28px', xs: '18px' } }} fontWeight={600} color="#000">
                    {item.video.title.slice(0, 25)}...
                  </Typography>
                  <Typography fontSize="14px" color="#000">
                    {item.video.channelName}
                  </Typography>
                </Box>
              </a>
            ))
          }
        </Stack>
      </Box>
    </div>
  )
}

export default ExerciseVideo
